/** Azerbaijani. Same keys as English (see en.ts). */
export const az: Record<string, string> = {
  'app.title': 'Spin the Bottle',

  'common.ok': 'Oldu',
  'common.cancel': 'Ləğv et',
  'common.close': 'Bağla',
  'common.back': 'Geri',
  'common.retry': 'Yenidən cəhd et',
  'common.save': 'Yadda saxla',
  'common.send': 'Göndər',
  'common.loading': 'Yüklənir…',
  'common.reconnecting': 'Bağlantı kəsildi. Yenidən qoşulur…',
  'common.offline': 'İnternet yoxdur',
  'common.hearts': '❤ {count}',
  'common.optional': 'istəyə görə',

  'errors.BAD_REQUEST': 'Sorğuda xəta var.',
  'errors.VALIDATION_FAILED': 'Daxil etdiklərinizi yoxlayın.',
  'errors.UNAUTHORIZED': 'Oyunu Telegram-dan yenidən açın.',
  'errors.TOKEN_EXPIRED': 'Sessiyanın vaxtı bitdi. Yenidən qoşulur…',
  'errors.FORBIDDEN': 'Bunu edə bilməzsiniz.',
  'errors.NOT_FOUND': 'Tapılmadı.',
  'errors.CONFLICT': 'Bunu başqası dəyişdi. Yenidən cəhd edin.',
  'errors.UNPROCESSABLE': 'Bu əməliyyat hazırda mümkün deyil.',
  'errors.RATE_LIMITED': 'Çox sürətli! Bir az gözləyin.',
  'errors.PAYLOAD_TOO_LARGE': 'Bu çox uzundur.',
  'errors.UNIQUE_VIOLATION': 'Bu artıq mövcuddur.',
  'errors.INTERNAL_ERROR': 'Nəsə səhv getdi. Yenidən cəhd edin.',
  'errors.SERVICE_UNAVAILABLE': 'Oyun yenidən başladılır. Bir azdan qayıdacaq.',
  'errors.INIT_DATA_INVALID': 'Oyunu Telegram botundan açın.',
  'errors.INIT_DATA_EXPIRED': 'Bu keçid köhnədir. Oyunu botdan yenidən açın.',
  'errors.BANNED': 'Hesabınız bloklanıb.',
  'errors.ONBOARDING_REQUIRED': 'Əvvəlcə profilinizi tamamlayın.',
  'errors.SESSION_REPLACED': 'Oyun başqa cihazda açıldı.',
  'errors.LOGIN_FAILED': 'Login və ya şifrə yanlışdır.',
  'errors.WRONG_PASSWORD': 'Cari şifrə yanlışdır.',
  'errors.ROOM_NOT_FOUND': 'Bu masa artıq yoxdur.',
  'errors.ROOM_FULL': 'Bu masa doludur.',
  'errors.ROOM_BUSY': 'Masa məşğuldur. Yenidən cəhd edin.',
  'errors.NOT_IN_ROOM': 'Siz masada deyilsiniz.',
  'errors.NOT_YOUR_TURN': 'Sizin növbəniz deyil.',
  'errors.NOT_IN_ROUND': 'Siz bu raundda iştirak etmirsiniz.',
  'errors.STALE_TURN': 'Artıq gecdir.',
  'errors.ALREADY_DECIDED': 'Siz artıq seçim etmisiniz.',
  'errors.MUTED': 'Hazırda yaza bilməzsiniz.',
  'errors.BLOCKED': 'Bu oyunçu ilə əlaqə mümkün deyil.',
  'errors.MESSAGE_REJECTED': 'Bu mesaj göndərilə bilməz. Keçidlər və təhqiramiz sözlər qadağandır.',
  'errors.CANNOT_TARGET_SELF': 'Bunu özünüzə edə bilməzsiniz.',
  'errors.INSUFFICIENT_FUNDS': 'Ürək kifayət etmir.',
  'errors.INSUFFICIENT_GM': 'GM kifayət etmir.',
  'errors.TRANSFER_LIMIT': 'Bu gün kifayət qədər göndərdiniz. Sabah yenidən cəhd edin.',
  'errors.NOT_FRIENDS': 'Yalnız dostlarınıza göndərə bilərsiniz.',
  'errors.ALREADY_CLAIMED': 'Bu gün artıq alınıb. Sabah qayıdın!',
  'errors.GIFT_NOT_FOUND': 'Bu hədiyyə mövcud deyil.',
  'errors.VIDEO_UNAVAILABLE': 'Bu video oyunda oynadıla bilməz. Başqa keçid yoxlayın.',
  'errors.NO_CHANCES': 'Şansınız qalmayıb.',
  'errors.NO_BOOSTER': 'Bu buster sizdə yoxdur.',
  'errors.PRODUCT_NOT_FOUND': 'Bu paket mövcud deyil.',

  'gender.MALE': 'Kişi',
  'gender.FEMALE': 'Qadın',
  'locale.en': 'English',
  'locale.ru': 'Русский',
  'locale.uz': 'Oʻzbekcha',
  'locale.az': 'Azərbaycanca',
  'locale.tr': 'Türkçe',

  'onboarding.title': 'Spin the Bottle-a xoş gəlmisiniz!',
  'onboarding.subtitle': 'Butulkanı fırlat, öpüş, hədiyyə göndər və yeni insanlarla tanış ol.',
  'onboarding.language': 'Dil',
  'onboarding.name': 'Masadakı ad',
  'onboarding.gender': 'Cinsiyyətim',
  'onboarding.birth_year': 'Doğum ili',
  'onboarding.birth_year_hint': 'Adınızın yanında yaşınız kimi göstərilir',
  'onboarding.rules_title': 'Masa qaydaları',
  'onboarding.rule_respect': 'Mehriban olun. Təhqir, spam və keçidlər qadağandır.',
  'onboarding.rule_virtual': 'Öpüşlər və hədiyyələr virtualdır, sadəcə əyləncə üçündür.',
  'onboarding.rule_block': 'İstənilən vaxt istənilən oyunçunu bloklaya və ya ondan şikayət edə bilərsiniz.',
  'onboarding.adult': '18 yaşım tamamdır və masa qaydalarını qəbul edirəm',
  'onboarding.start': 'Oynayaq',
  'onboarding.underage': 'Bağışlayın, oyun yalnız 18 yaşdan yuxarı oyunçular üçündür.',

  'lobby.play': 'PLAY',
  'lobby.balance': 'Ürəkləriniz',
  'lobby.ratings': 'Reytinqlər',
  'lobby.achievements': 'Nailiyyətlər',
  'lobby.shop': 'Ürək al',
  'lobby.settings': 'Ayarlar',
  'lobby.invite': 'Dostları dəvət et',
  'lobby.profile': 'Profil',

  'table.title': 'Masa {code}',
  'table.waiting_players': 'Daha çox oyunçu gözlənilir…',
  'table.waiting_turn': 'Növbəti gediş gözlənilir',
  'table.your_turn': 'Butulkanı fırlat!',
  'table.tap_bottle': 'Butulkaya toxun',
  'table.spins': 'Butulkanı fırladır',
  'table.your_choice': 'Sənin seçimin',
  'table.kiss_back': 'Cavab olaraq öpəcəkmi?',
  'table.will_they': 'Öpüşəcəklərmi?',
  'table.kiss': 'Öp',
  'table.refuse': 'İmtina',
  'table.result_mutual': 'Qarşılıqlı öpüş! 💋',
  'table.result_one': '{from} {to} adlı oyunçunu öpdü 💋',
  'table.result_none': 'Bu dəfə öpüş olmadı',
  'table.change': 'Masanı dəyiş',
  'table.leave': 'Masadan çıx',
  'table.chat_placeholder': 'Mesajınızı yazın',
  'table.chat_empty': 'Hamıya salam de 👋',
  'table.music_on': 'Musiqi açıq',
  'table.music_off': 'Musiqi bağlı',
  'table.now_playing': 'İndi səslənir',
  'table.tap_to_listen': 'Dinləmək üçün toxun',
  'table.music_error': 'Bu video burada oynadıla bilməz',
  'table.dj_title': 'Masa üçün mahnı sifariş et',
  'table.dj_hint': 'YouTube keçidini yapışdırın. Masadakı hər kəs eşidəcək.',
  'table.dj_order': '❤ {price} ilə sifariş et',
  'table.dj_queue': 'Növbədə: {count}',
  'table.idle_kicked': 'Aktiv olmadığınız üçün masadan çıxarıldınız.',
  'table.session_replaced': 'Oyun başqa cihazda açıldı.',
  'table.kisses.one': '{count} öpüş',
  'table.kisses.other': '{count} öpüş',
  'table.joined': '{name} masaya qoşuldu',
  'table.left': '{name} masadan çıxdı',
  'table.gift_sent': '{from} {to} üçün {emoji} göndərdi',
  'table.dj_dedicated': '{name} {to} üçün mahnı həsr etdi: {title}',
  'table.dj_for': '{name} üçün',
  'table.dj_dedicate': '{name} üçün mahnı həsr et',
  'table.dj_video': 'Klip kimi göstər (❤ {price})',
  'gifts.category.romance': 'Romantika',
  'gifts.category.hats': 'Papaqlar və taclar',
  'gifts.category.animals': 'Heyvanlar',
  'gifts.category.music': 'Musiqi',
  'gifts.category.vip': 'VIP',
  'table.dj_ordered': '{name} mahnı sifariş etdi: {title}',

  'player.send_gift': 'Hədiyyə göndər',
  'player.hidden_message': 'Gizli mesaj',
  'player.dare': 'Cəsarət tapşırığı',
  'player.admire': '❤ {price} ilə heyran ol',
  'player.admirer': 'Heyranı: {name} (❤ {price})',
  'player.no_admirer': 'Hələ heyranı yoxdur',
  'player.block': 'Blokla',
  'player.unblock': 'Blokdan çıxar',
  'player.report': 'Şikayət et',
  'player.you': 'Bu sənsən',
  'player.achievements.one': '{count} nailiyyət',
  'player.achievements.other': '{count} nailiyyət',

  'gifts.title': '{name} üçün hədiyyə',
  'gifts.category.flowers': 'Güllər',
  'gifts.category.drinks': 'İçkilər',
  'gifts.category.sweets': 'Şirniyyatlar',
  'gifts.category.fun': 'Əyləncə',
  'gifts.category.status': 'Lüks',
  'gifts.category.pranks': 'Zarafatlar',
  'gifts.category.seasonal': 'Mövsümi',

  'ratings.title': 'Reytinqlər',
  'ratings.kisses': 'Ən çox öpülən',
  'ratings.dj': 'Ən yaxşı DJ-lər',
  'ratings.day': 'Bu gün',
  'ratings.week': 'Bu həftə',
  'ratings.month': 'Bu ay',
  'ratings.all': 'Bütün dövr',
  'ratings.you': 'Siz',
  'ratings.empty': 'Hələ heç kim yoxdur. Birinci ol!',

  'achievements.title': 'Nailiyyətlər',
  'achievements.progress': '{progress} / {threshold}',
  'achievements.reward': 'Mükafat: ❤ {reward}',

  'errors.VIP_REQUIRED': 'Bu VIP oyunçular üçündür.',
  'errors.NOT_OWNED': 'Bu əşya hələ sizdə yoxdur.',
  'lobby.vip': 'VIP',
  'lobby.styling': 'Stil',
  'vip.title': 'VIP status',
  'vip.active_until': 'VIP {date} tarixinədək',
  'vip.inactive': 'Hər masada fərqlən.',
  'vip.perk_name': 'Masada və çatda qızılı ad və VIP nişanı',
  'vip.perk_bottle': 'Masan üçün VIP butulka',
  'vip.perk_frames': 'Eksklüziv VIP çərçivələr',
  'vip.perk_gifts': 'VIP hədiyyələr və stikerlər',
  'vip.plan': '{days} gün',
  'vip.buy': '❤ {price} ilə al',
  'vip.extend': '❤ {price} ilə uzat',
  'vip.bought': '{date} tarixinədək VIP-siniz! 👑',
  'styling.title': 'Stil',
  'styling.none': 'Stilsiz',
  'styling.none_hint': 'Profil şəkli və istifadəçi adı stilsiz qalsın',
  'styling.buy': '❤ {price} ilə al',
  'styling.equip': 'Tax',
  'styling.equipped': 'Taxılıb',
  'styling.remove': 'Çıxar',
  'styling.owned': 'Sizindir',
  'styling.vip_only': 'Yalnız VIP',
  'styling.reward.league_champion': 'Mükafat: liqa gününü qazan',
  'styling.reward.kiss_master': 'Mükafat: 1000 öpüş al',
  'bottle.put': '❤ {price} ilə masaya qoy',
  'bottle.pick': 'Butulka seç',
  'bottle.title': 'Butulkanı dəyiş',
  'bottle.hint': 'Butulka bu masadakı hər kəs üçün dəyişir.',
  'bottle.current': 'Masadadır',
  'bottle.changed': '{name} masaya “{skin}” butulkasını qoydu 🍾',
  'table.change_bottle': 'Butulkanı dəyiş',
  'bottle.classic': 'Klassik',
  'bottle.emerald': 'Zümrüd',
  'bottle.amber': 'Kəhrəba',
  'bottle.champagne': 'Şampan',
  'bottle.cola': 'Kola',
  'bottle.lemonade': 'Limonad',
  'bottle.whisky': 'Viski',
  'bottle.wine': 'Qırmızı şərab',
  'bottle.sparkle': 'Parıltı',
  'bottle.ice': 'Buz',
  'bottle.gold': 'Qızıl',
  'bottle.potion': 'Sevgi iksiri',
  'bottle.baby': 'Uşaq butulkası',
  'bottle.vip': 'VIP',
  'frame.rose_garden': 'Qızılgül bağı',
  'frame.neon_pink': 'Neon çəhrayı',
  'frame.neon_cyan': 'Neon mavi',
  'frame.hearts': 'Ürəklər',
  'frame.candy': 'Konfet',
  'frame.bow': 'Bant',
  'frame.leaves': 'Payız',
  'frame.flame': 'Alov',
  'frame.ice': 'Buz',
  'frame.butterfly': 'Kəpənək',
  'frame.emerald': 'Zümrüd',
  'frame.ruby': 'Yaqut',
  'frame.sapphire': 'Sapfir',
  'frame.devil': 'Şeytancıq',
  'frame.angel': 'Mələk',
  'frame.galaxy': 'Qalaktika',
  'frame.rainbow': 'Göy qurşağı',
  'frame.royal': 'Kral',
  'frame.vip_gold': 'VIP qızıl',
  'frame.vip_diamond': 'VIP almaz',
  'frame.league_champion': 'Liqa çempionu',
  'frame.kiss_master': 'Öpüş ustası',
  'stickers.title': 'Mənim Stikerlərim',
  'stickers.pack.basic': 'Əsas',
  'stickers.pack.love': 'Sevgi',
  'stickers.pack.party': 'Parti',
  'stickers.pack.animals': 'Heyvanlar',
  'stickers.pack.vip': 'VIP',
  'stickers.cost': 'Hər stiker ❤ {price} dəyərindədir və avatarınızın üzərində uçur.',
  'stickers.buy': '❤ {price} ilə aç',
  'stickers.vip_only': 'VIP oyunçular üçün',
  'ratings.emotional': 'Ən emosional',
  'wheel.title': 'Bəxt Çarxı',
  'wheel.spin': 'Fırlat',
  'wheel.chances': 'Şanslar: {count}',
  'wheel.free': 'Günün pulsuz şansı',
  'wheel.free_taken': 'Pulsuz şans üçün sabah qayıdın',
  'wheel.shop': 'Şans dükanı',
  'wheel.pack': '{count} şans',
  'wheel.pack_one': '1 şans',
  'wheel.help': 'Necə işləyir',
  'wheel.help_text':
    'Hər fırlatma bir şansdır. Mükafatları server aşağıdakı ehtimallarla seçir; qazandığınız şansları yenidən xərcləyə bilərsiniz. Busterlərdən liqa ekranında istifadə olunur.',
  'wheel.odds': 'Ehtimallar',
  'wheel.won': 'Qazandınız: {prize}',
  'wheel.jackpot_banner': '🎰 {name} cekpotu qazandı: {prize}!',
  'wheel.big_win_banner': '🎡 {name} çarxda {prize} qazandı',
  'wheel.need_chance': 'Şansınız qalmayıb: sabah pulsuz şans alın və ya aşağıdan satın alın.',
  'wheel.boosters': 'Busterlərim',
  'wheel.prize.hearts_3': '❤ 3',
  'wheel.prize.hearts_5': '❤ 5',
  'wheel.prize.hearts_25': '❤ 25',
  'wheel.prize.hearts_100': '❤ 100',
  'wheel.prize.jackpot': 'Cekpot ❤ 1000',
  'wheel.prize.chance_1': '+1 şans',
  'wheel.prize.chance_3': '+3 şans',
  'wheel.prize.boost_x2': 'Buster ×2',
  'wheel.prize.boost_limit': 'Buster +10 limit',
  'wheel.prize.boost_bonus': 'Buster +5 xal',
  'booster.x2': 'Liqa xallarını ikiqat et',
  'booster.x2_desc': 'Aldığınız öpüşlər 5 dəqiqə ikiqat sayılır (öpüş hədiyyələri istisnadır).',
  'booster.limit': 'Liqa limitini artır',
  'booster.limit_desc': 'Bu gün alınan öpüşlərdən gələn xal limiti 10 artır.',
  'booster.bonus': 'Bonus liqa xalları',
  'booster.bonus_desc': 'Dərhal +5 liqa xalı, istənilən limitdən əlavə.',
  'lobby.wheel': 'Çarx',
  'league.title': 'Liqalar',
  'league.tier.wooden': 'Taxta liqa',
  'league.tier.bronze': 'Bürünc liqa',
  'league.tier.silver': 'Gümüş liqa',
  'league.tier.gold': 'Qızıl liqa',
  'league.tier.platinum': 'Platin liqa',
  'league.tier.diamond': 'Almaz liqa',
  'league.ends_in': 'Yekun nəticələr {h} saat {m} dəq sonra',
  'league.points': '★ {points}',
  'league.kiss_limit': 'Bu gün öpüş xalları: {used} / {cap}',
  'league.zone_up': 'Növbəti liqaya keç',
  'league.zone_down': 'Əvvəlki liqaya düş',
  'league.rewards': 'Mükafatlar',
  'league.chest.red': 'Qırmızı sandıq',
  'league.chest.blue': 'Mavi sandıq',
  'league.chest.wooden': 'Taxta sandıq',
  'league.chest.box': 'Hədiyyə qutusu',
  'league.chest_contents': '❤ {hearts} + 🎲 {chances}',
  'league.box_contents': '{points}+ xal üçün 🎲 {chances}',
  'league.place': '{place}. yer',
  'league.empty':
    'Qrupa qoşulmaq üçün bu gün ilk xallarınızı qazanın: hədiyyə göndərin, mahnı sifariş edin, oyunçulara heyran olun və ya öpüş alın.',
  'league.rules': 'Qaydalar',
  'league.rules_text':
    'Liqalar gündəlik yarışlardır. Hədiyyələrə, musiqiyə və heyranlığa xərclənən hər ürək üçün və aldığınız hər öpüş üçün (gündə ən çox {cap} xal) bir xal qazanırsınız. Günün sonunda hər qrupun ilk {promote} oyunçusu bir liqa yuxarı qalxır, son {demote} oyunçu isə bir liqa aşağı düşür ({min}+ oyunçulu qruplarda). İlk 3 yer sandıq, {box}+ xalı olan hər kəs isə hədiyyə qutusu alır.',
  'league.use': 'İstifadə et',
  'league.x2_active': '×2 aktivdir: {time}',
  'league.used.x2': 'Alınan öpüşlər 5 dəqiqə ikiqat sayılır!',
  'league.used.limit': 'Bu günkü öpüş limitiniz 10 artdı.',
  'league.used.bonus': '+5 liqa xalı!',
  'league.last_result': 'Son nəticə: {tier} — {place}. yer',
  'league.moved_up': '⬆ Yüksəldi',
  'league.moved_down': '⬇ Düşdü',
  'league.stayed': 'Yerində qaldı',
  'league.result_toast': 'Liqa nəticələri: {place}. yer. {chest}',
  'league.get_boosters': 'Busterləri Bəxt Çarxında qazanın',
  'lobby.league': 'Liqa',
  'achievement.kisser.title': 'Öpüşkən',
  'achievement.kisser.desc': 'Verilən öpüşlər: {count}',
  'achievement.popular.title': 'Populyar',
  'achievement.popular.desc': 'Alınan öpüşlər: {count}',
  'achievement.mutual.title': 'Sevgililər',
  'achievement.mutual.desc': 'Qarşılıqlı öpüşlər: {count}',
  'achievement.spinner.title': 'Butulka ustası',
  'achievement.spinner.desc': 'Butulka fırlatmaları: {count}',
  'achievement.regular.title': 'Daimi oyunçu',
  'achievement.regular.desc': 'Oynanan raundlar: {count}',
  'achievement.generous.title': 'Səxavətli',
  'achievement.generous.desc': 'Göndərilən hədiyyələr: {count}',
  'achievement.adored.title': 'Sevimli',
  'achievement.adored.desc': 'Alınan hədiyyələr: {count}',
  'achievement.dj.title': 'DJ',
  'achievement.dj.desc': 'Sifariş edilən mahnılar: {count}',
  'achievement.chatty.title': 'Danışqan',
  'achievement.chatty.desc': 'Çat mesajları: {count}',
  'achievement.daredevil.title': 'Cəsur',
  'achievement.daredevil.desc': 'Qəbul edilən tapşırıqlar: {count}',
  'achievement.streak.title': 'Sadiq',
  'achievement.streak.desc': 'Ardıcıl gündəlik bonus günləri: {count}',
  'achievement.emotional.title': 'Emosional',
  'achievement.emotional.desc': 'Göndərilən stikerlər: {count}',
  'achievement.lucky.title': 'Şanslı',
  'achievement.lucky.desc': 'Çarx fırlatmaları: {count}',
  'achievement.admirer.title': 'Heyran',
  'achievement.admirer.desc': 'Heyran olunan oyunçular: {count}',
  'achievement.charmer.title': 'Cazibədar',
  'achievement.charmer.desc': 'Sizə heyran olunma sayı: {count}',
  'achievement.champion.title': 'Çempion',
  'achievement.champion.desc': 'Qazanılan liqa sandıqları: {count}',
  'achievement.league.title': 'Yüksələn',
  'achievement.league.desc': 'Çatılan liqa: {count} / 5',
  'achievement.bartender.title': 'Barmen',
  'achievement.bartender.desc': 'Dəyişdirilən masa butulkaları: {count}',
  'achievement.secret.title': 'Gizli heyran',
  'achievement.secret.desc': 'Göndərilən gizli mesajlar: {count}',
  'ratings.expensive': 'Ən bahalı',
  'ratings.important': 'Ən vacib',
  'ratings.top': 'TOP',
  'ratings.help.kisses': 'Alınan öpüşlər, öpüş hədiyyələri daxil.',
  'ratings.help.dj':
    'Musiqiyə xərclənən ürəklər, üstəlik mahnınız səslənərkən aldığınız hər hədiyyə üçün bir xal.',
  'ratings.help.expensive': 'Sonuncu heyranlıq qiymətiniz və ya heyranınızı rədd etdiyiniz qiymət.',
  'ratings.help.important':
    'Başqalarına heyranlığa xərclənən ürəklər; rədd edildikdə və ya başqası sizi qabaqladıqda geri çıxılır.',
  'ratings.help.emotional': 'Stikerlərə (jestlərə) xərclənən ürəklər.',
  'achievements.stars': '★ {stars} / {total}',
  'achievements.filter.all': 'Hamısı',
  'achievements.filter.done': 'Tamamlanmış',
  'achievements.filter.locked': 'Bağlı',
  'achievements.next': 'Növbəti ulduz: {progress} / {goal} · ❤ {reward}',
  'achievements.complete': 'Bütün ulduzlar qazanılıb!',
  'player.turn_down': 'Heyranı rədd et',
  'player.turned_down': '{name} adlı heyranı rədd etdiniz',
  'notify.turned_down': '{name} sizi rədd etdi',
  'activity.title': 'Bonus & Reytinq',
  'activity.today': 'Bu gün',
  'activity.yesterday': 'Dünən',
  'activity.time': 'Aktivlik vaxtı',
  'activity.time_value': '{h} saat {m} dəq',
  'activity.milestone': '{hours} saat → ❤ {reward}',
  'activity.points': 'Aktivlik xalları',
  'activity.how': 'Xal qaydaları',
  'activity.kind.message': 'Mesaj',
  'activity.kind.song': 'Mahnı',
  'activity.kind.booster': 'Buster',
  'activity.kind.gift': 'Hədiyyə',
  'activity.kind.round': 'Raund',
  'activity.kind.sticker': 'Stiker',
  'activity.kind.wheel': 'Çarx',
  'activity.rules':
    'Masada aktiv olduğunuz müddət sayılır (ən azı hər {gap} dəqiqədən bir hərəkət). Gündə ən çox {cap} çat mesajı xal gətirir. Gündəlik top gecə yarısı bağlanır; ilk {places} yer ürək alır. Spam sayılmır.',
  'activity.top': 'Gündəlik top {size}',
  'activity.prize': '❤ {hearts}',
  'activity.ends_in': '{h} saat {m} dəq sonra bağlanır',
  'activity.empty': 'Bu gün hələ aktivlik yoxdur.',
  'activity.reward_toast': 'Aktivlik mükafatı: ❤ {hearts}',
  'activity.top_toast': 'Gündəlik aktivlik topu: {place}. yer, ❤ {hearts}',
  'lobby.bonus': 'Bonus',
  'friends.title': 'Dostlar siyahısı',
  'friends.add': 'Dost əlavə et',
  'friends.requested': 'Sorğu göndərildi',
  'friends.accept': 'Qəbul et',
  'friends.decline': 'İmtina et',
  'friends.remove': 'Dostlardan sil',
  'friends.friends': 'Dostlar',
  'friends.incoming': 'Dostluq sorğuları',
  'friends.outgoing': 'Göndərilən sorğular',
  'friends.empty': 'Hələ dost yoxdur.',
  'friends.online': 'onlayn',
  'friends.at_table': 'masadadır',
  'friends.join': 'Qoşul',
  'friends.count': 'Dostlar: {count}',
  'friends.hidden': 'Dostlar gizlidir',
  'friends.privacy': 'Dostlarımı kim görsün',
  'friends.privacy.everyone': 'Hər kəs',
  'friends.privacy.me': 'Yalnız mən',
  'notify.friend_request': '{name} sizinlə dost olmaq istəyir',
  'notify.friend_accepted': '{name} dostluq sorğunuzu qəbul etdi',
  'lobby.friends': 'Dostlar',
  'settings.gender': 'Cins',
  'settings.gender_hint': 'Bunu {days} gündə bir dəfə dəyişə bilərsiniz, masada oturarkən yox.',
  'settings.gender_next': 'Növbəti dəyişiklik: {date}',
  'errors.GENDER_COOLDOWN': 'Cinsinizi bu yaxınlarda dəyişmisiniz. Sonra yenidən cəhd edin.',
  'errors.TOO_MANY_FRIENDS': 'Dost siyahınız doludur.',
  'errors.TRANSLATION_UNAVAILABLE': 'Tərcümə hazırda mümkün deyil.',
  'table.show_translation': 'Tərcüməni göstər',
  'table.hide_translation': 'Tərcüməni gizlət',
  'table.translating': 'Tərcümə olunur…',
  'player.league': '{league}',
  'player.send_gift_title': '{name} üçün hədiyyə göndər',
  'settings.photo_change': 'Şəkli dəyiş',
  'settings.photo_reset': 'Telegram şəklimi istifadə et',
  'settings.photo_hint':
    'Öz şəklinizi yükləyənə qədər Telegram şəkliniz istifadə olunur. Uyğunsuz şəkillər silinir və bloklanmaya səbəb ola bilər.',
  'settings.photo_preview': 'Yeni şəkil',
  'settings.photo_saved': 'Şəkil yeniləndi',
  'settings.name_reset': 'Telegram adımı istifadə et',
  'errors.UNSUPPORTED_IMAGE': 'Bu şəkil istifadə oluna bilməz. Başqa şəkil yoxlayın.',
  'lobby.domino': 'Domino',
  'domino.title': 'Domino',
  'domino.rules': 'Bazarlı klassik domino · {target} xala ilk çatan bankı götürür',
  'domino.rake': 'Ev payı {percent}%',
  'domino.quick': 'Sürətli oyun',
  'domino.free': 'Pulsuz',
  'domino.create': 'Otaq aç',
  'domino.seats': 'Oyunçular',
  'domino.stake_label': 'Mərc',
  'domino.open_rooms': 'Oyunçu gözləyən otaqlar',
  'domino.no_rooms': 'Hələ açıq otaq yoxdur: otaq açın və ya sürətli oyuna başlayın.',
  'domino.join': 'Qoşul',
  'domino.back_to_game': 'Siz otaqdasınız: oyuna qayıt',
  'domino.waiting': 'Oyunçular gözlənilir… {n}/{seats}',
  'domino.leave': 'Çıx',
  'domino.leave_confirm': 'Oyundan çıxırsınız? Uduzursunuz və mərciniz bankda qalır.',
  'domino.leave_refund': 'Otaqdan çıx (mərciniz geri qaytarılır)',
  'domino.pot': 'Bank ❤ {pot}',
  'domino.round': 'Raund {round} · hədəf {target}',
  'domino.your_turn': 'Sizin növbəniz',
  'domino.turn_of': '{name} gedir',
  'domino.draw': 'Götür ({n})',
  'domino.pass': 'Pas',
  'domino.choose_end': 'Hansı uc?',
  'domino.left': '◀ Sol',
  'domino.right': 'Sağ ▶',
  'domino.boneyard': 'Bazar {n}',
  'domino.drew': '{name} {n} daş götürdü',
  'domino.passed': '{name} pas dedi',
  'domino.auto': '{name} vaxtı bitdi',
  'domino.round_won': '{name} raundu qazandı: +{points}',
  'domino.round_blocked': 'Bağlandı! Ən az xal: {name}, +{points}',
  'domino.round_tie': 'Bərabərliklə bağlandı: bu raund xal yoxdur',
  'domino.next_round': 'Növbəti raund {s} san sonra',
  'domino.game_won': '{name} oyunu qazandı!',
  'domino.you_won': '❤ {payout} qazandınız!',
  'domino.out': 'çıxdı',
  'domino.to_lobby': 'Otaqlara qayıt',
  'domino.cancelled': 'Otaq bağlandı; mərclər geri qaytarıldı.',
  'domino.started': 'Domino oyununuz başladı!',
  'domino.points': '{score} xal',
  'domino.empty_seat': 'Boş yer',
  'domino.first_move': 'İşıqlanan cüt daşla başlayın',
  'errors.ILLEGAL_MOVE': 'Bu daş ora uyğun gəlmir.',
  'errors.DOMINO_DISABLED': 'Domino mövcud deyil.',
  'errors.ALREADY_IN_GAME': 'Siz artıq domino otağındasınız.',
  'lobby.live': 'Canlı',
  'live.title': 'Canlı',
  'live.go_live': 'Canlı yayına başla',
  'live.vip_only': 'Canlı yayını VIP oyunçular açır; hər kəs izləyə bilər.',
  'live.connect_failed':
    'Yayımın videosuna qoşulmaq alınmadı. İnterneti yoxlayın (və ya mobil internetlə yoxlayın) və yenidən açın.',
  'live.no_webrtc':
    'Bu Telegram tətbiqi canlı videonu oynatmır. Oyunu telefondakı Telegramda və ya web.telegram.org-da açın.',
  'live.empty': 'Hazırda heç kim canlı yayında deyil.',
  'live.viewers': '{n} izləyir',
  'live.start_title': 'Sizin yayınınız',
  'live.title_placeholder': 'Yayınınız nə haqqındadır?',
  'live.rules':
    '18 yaşım var. Çılpaqlıq və ya yetkinlik yaşına çatmayanları göstərməyəcəyəm və əlaqə məlumatı paylaşmayacağam. Qaydaları pozmaq yayını bitirir və hesabın bloklanmasına səbəb ola bilər.',
  'live.start': 'Yayına başla',
  'live.camera_needed': 'Canlı yayın üçün kamera və mikrofona icazə verin',
  'live.end': 'Yayını bitir',
  'live.end_confirm': 'Yayını indi bitirirsiniz?',
  'live.ended': 'Yayın bitdi',
  'live.ended_reports': 'Yayın şikayətlərdən sonra dayandırıldı',
  'live.ended_admin': 'Admin yayını dayandırdı',
  'live.ended_lost': 'Yayımçının bağlantısı kəsildi',
  'live.back': 'Yayınlara qayıt',
  'live.chat_placeholder': 'Xoş bir şey yazın…',
  'live.sent_gift': '{name} {emoji} göndərdi',
  'live.report': 'Şikayət et',
  'live.reported': 'Təşəkkürlər, adminlər baxacaq.',
  'live.tap_sound': '🔊 Səs üçün toxun',
  'live.connecting': 'Qoşulur…',
  'live.gift_title': '{name} üçün hədiyyə',
  'live.you_are_live': 'Siz canlı yayındasınız',
  'live.waiting_video': 'Video gözlənilir…',
  'live.like': 'Bəyən',
  'live.gift': 'Hədiyyə',
  'live.camera': 'Kamera',
  'live.admin_tab': 'Canlı',
  'live.admin_end': 'Bitir',
  'live.admin_reports': '{n} şikayət',
  'live.admin_none': 'Hələ yayın yoxdur.',
  'errors.LIVE_DISABLED': 'Canlı yayınlar mövcud deyil.',
  'errors.ALREADY_LIVE': 'Siz artıq canlı yayındasınız.',
  'errors.STREAM_ENDED': 'Yayın bitib.',

  'settings.title': 'Ayarlar',
  'settings.sound': 'Səslər',
  'settings.music': 'Musiqi',
  'settings.notifications': 'Gizli mesajlar barədə botda xəbər ver',
  'settings.language': 'Dil',
  'settings.name': 'Masadakı ad',
  'settings.birth_year': 'Doğum ili',
  'settings.blocked': 'Bloklanan oyunçular',
  'settings.support': 'Dəstək',
  'settings.saved': 'Yadda saxlanıldı',

  'invite.title': 'Dostları dəvət et',
  'invite.text': 'Dostunuz ilk raundunu oynayanda həm siz, həm də o ❤ {bonus} alırsınız.',
  'invite.share': 'Dəvət keçidini paylaş',
  'invite.copy': 'Keçidi kopyala',
  'invite.copied': 'Keçid kopyalandı',
  'invite.stats': 'Dəvət olunub: {invited} · Mükafat alınıb: {rewarded}',
  'invite.share_text': 'Spin the Bottle-da mənə qoşul! 🍾💋',

  'notify.admired': '{name} ❤ {price} ilə sizə heyran oldu',
  'notify.outbid': '{name} {target} üçün heyranlıqda sizi qabaqladı',
  'notify.gift': '{name} sizə {emoji} göndərdi',
  'notify.achievement': 'Nailiyyət: {title} ★{level} (+❤ {reward})',
  'notify.referral': '+❤ {bonus}: {name} dəvətinizlə oyuna qoşuldu!',
  'notify.wallet': '+❤ {amount}',
  'notify.gm': '💰 +{amount} GM',
  'notify.transfer_gm': '{name} sizə {amount} GM göndərdi',
  'notify.transfer_hearts': '{name} sizə ❤ {amount} göndərdi',

  'admin.live_reported': '🔴 {name} adlı oyunçunun canlı yayını {reports} şikayətdən sonra dayandırıldı.',
  'admin.auto_mute': '⚠️ Avtomatik susdurma: {userId} oyunçusu 24 saatda {reports} şikayət aldı.',
  'admin.broadcast_done': '📣 Yayım bitdi: göndərildi {sent}, alınmadı {failed}.',

  'bot.welcome':
    'Salam! Ən yaxşı Spin the Bottle macərasına hazır ol.\n\n👀 Ətrafındakıları gör və söhbətə başla\n🎁 Əyləncəli sürprizlər və cəsarət tapşırıqları ilə bölüş\n💌 Xüsusi birinə gizli mesajlar göndər\n🎲 Otaqda birlikdə maraqlı oyunlardan zövq al\n🎶 Arxa fonda səslənən musiqi ilə birlikdə oyna\n\n🎮 PLAY-ə toxun və əyləncə başlasın!',
  'bot.play_button': '🎮 PLAY',
  'bot.menu_button': 'PLAY',
  'bot.help': 'Spin the Bottle Mini App-da oynanılır: 🎮 PLAY-ə toxun.',
  'bot.rate_limited': 'Çox sorğu var. Bir az yavaşlayın.',
  'bot.banned': 'Hesabınız bloklanıb.',
  'bot.gm_credited': '💰 Hesabınıza +{amount} GM köçürüldü. Balans: {gm} GM',
  'bot.gm_debited': '💰 Admin hesabınızdan {amount} GM çıxdı. Balans: {gm} GM',
  'bot.short_description': 'Butulkanı fırlat, öpüş, hədiyyə göndər və musiqi qoy 💋',
  'bot.description':
    'Telegram-da klassik Spin the Bottle oyunu: 12 nəfərlik masalar, öpüşlər, hədiyyələr, liqalar, Bəxt Çarxı və musiqi. 18+.',
  'bar.heart_shop': 'Ürək dükanı',
  'bar.wheel': 'Bəxt Çarxı',
  'bar.league': 'Liqa',
  'bar.misc': 'Digər',
  'bar.settings': 'Ayarlar',
  'bar.exit': 'Çıxış',
  'bar.table': 'Masa',
  'bar.change_table': 'Masanı dəyiş',
  'menu.achievements': 'Nailiyyətlər',
  'menu.ratings': 'Reytinqlər',
  'menu.bottle': 'Butulka',
  'menu.styling': 'Stil',
  'menu.boosters': 'Busterlər',
  'table.spin_the_bottle': 'Butulkanı fırlat!',
  'table.spins_the_bottle': 'Butulkanı fırladır',
  'table.order_song': '❤ {price} ilə mahnı sifariş et',
  'table.order_video': '❤ {price} ilə klip sifariş et',
  'table.video_size': 'Video ölçüsü',
  'table.play_here': 'Burada oyna',
  'gifts.send_to': 'Hədiyyə göndər',
  'player.profile': 'Profil',
  'player.admire_for': 'Heyran ol',
  'player.reported': 'Təşəkkürlər, yoxlayacağıq.',
  'report.SPAM': 'Spam',
  'report.ABUSE': 'Təhqir',
  'report.SEXUAL_CONTENT': 'Cinsi məzmun',
  'report.UNDERAGE': '18 yaşdan kiçik',
  'report.OTHER': 'Digər',
  'shop.title': 'Ürək al',
  'shop.details': 'Ətraflı',
  'shop.vip_status': 'STATUS',
  'shop.for_friend_1': 'Dost üçün',
  'shop.for_friend_2': 'qazan',
  'shop.bonus': '{percent}% BONUS',
  'shop.best_offer': 'Ən sərfəli',
  'shop.best_pick': 'Ən yaxşı seçim',
  'shop.send': 'Göndər',
  'shop.need_gm': '{gm} GM lazımdır. GM balansını artırmaq üçün adminə yazın.',
  'shop.bought': '+❤ {hearts}',
  'shop.send_gm_title': 'Dosta GM {amount} göndər',
  'shop.send_hearts_title': 'Dosta ❤ {amount} göndər',
  'shop.send_left': 'Bu gün qalan göndərmələr: {count}',
  'shop.send_no_friends': 'Əvvəlcə dost əlavə edin: masadakı oyunçuya toxunun, sonra yaşıl +.',
  'shop.sent_gm': '{name} üçün {amount} GM göndərildi',
  'shop.sent_hearts': '{name} üçün ❤ {amount} göndərildi',
  'vip.perks':
    'VIP ol: unikal hədiyyələr göndər, emojilərdən istifadə et və xüsusi ad rəngi ilə hamıdan fərqlən!',
  'wheel.rules': '“Fırlat”a toxun — Bəxt Çarxını işə sal və mükafatını al!',
  'wheel.chances_label': 'Şanslar:',
  'wheel.price': 'Qiymət:',
  'wheel.winner': 'Qalib',
  'wheel.jackpot_text': 'cekpotu vurdu və ❤ 1000 qazandı',
  'wheel.big_win_text': '{prize} qazandı',
  'league.hint': 'Yuxarı yerlərə qalxmaq üçün busterlərdən istifadə et',
  'league.boosters': 'Busterlər',
  'league.zone_up_hint': 'yuxarı liqaya keçid',
  'league.final_in': 'Yekun nəticələr: {hours} saat sonra',
  'league.until_limit': 'Limitə qədər:',
  'league.activate': 'Aktivləşdir',
  'league.rules_1': 'Liqalar ürək və unikal hədiyyələr qazana biləcəyin gündəlik yarışlardır.',
  'league.rules_2':
    'Xallar hədiyyələr, alınan öpüşlər, səslənən musiqi və heyranlıq üçün verilir. Xərclənən hər ürək üçün bir xal: nə qədər çox hədiyyə göndərsən, bir o qədər çox xal qazanarsan.',
  'league.rules_3':
    'Günün sonunda ilk {promote} oyunçu növbəti liqaya qalxır və sandıq alır; son {demote} oyunçu aşağı düşür.',
  'league.rules_4':
    'Alınan öpüşlər gündə ən çox {cap} xal verir. Bəxt Çarxındakı busterlər kömək edir: ikiqat xal, daha yüksək limit və bonus xallar.',
  'achievements.mine': 'Mənim nailiyyətlərim',
  'achievements.count': '{stars}/{total}',
  'achievements.show_first': 'Əvvəlcə göstər:',
  'achievements.completed': 'tamamlanan',
  'achievements.locked': 'bağlı',
  'achievements.detail': 'Nailiyyət',
  'achievements.meet': 'Əldə etmək üçün şərtləri yerinə yetir:',
  'ratings.help_title': 'Bu reytinq haqqında',
  'ratings.period': 'Dövr',
  'ratings.top_n': 'Ən yaxşı {n} oyunçu',
  'ratings.period_all': 'bütün dövr',
  'ratings.period_month': 'bu ay',
  'ratings.period_week': 'bu həftə',
  'ratings.period_day': 'bu gün',
  'styling.apply': 'Tətbiq et',
  'styling.owned_hint': 'Bu çərçivə sizindir.',
  'styling.buy_hint': 'Bu çərçivəni ❤ {price} ilə al və tax.',
  'styling.locked': 'Bu çərçivə mükafatdır.',
  'settings.sounds': 'Səslər',
  'settings.invite': 'Dostları dəvət et',
  'settings.friends': 'Dostlarım',
  'settings.contact': 'Bizimlə əlaqə',
  'friends.who_sees': 'Dostluğumu kimlər görsün?',
  'friends.visibility_everyone': 'Hər kəs',
  'friends.visibility_me': 'Yalnız mən',
  'friends.sent': 'Göndərilən sorğular: {count}',
  'activity.hours': '{hours} saat',
  'activity.more': 'DAHA ÇOX',
  'activity.less': 'DAHA AZ',
  'activity.h': 's',
  'activity.m': 'd',
  'activity.pts': '{points} xal',
  'activity.my_place': 'Sizin yeriniz: #{rank} · {points} xal',
  'portal.logout': 'Çıxış',
  'portal.services': 'Xidmətlər',
  'portal.invited': 'Dəvət olunanlar',
  'portal.invited_empty': 'Hələ heç kim keçidinizlə qoşulmayıb.',
  'portal.no_status': 'Hələ status yoxdur',
  'portal.status_title': 'Statusunuz',
  'portal.status_placeholder': 'Özünüz haqqında nəsə yazın…',
  'portal.start': 'Başla',
  'portal.watch': 'İzlə',
  'portal.license': 'Lisenziya',
  'portal.license_title': '{name} v2',
  'portal.license_text':
    '© {year}. Bütün hüquqlar qorunur. Öpüşlər və hədiyyələr virtualdır, sadəcə əyləncə üçündür.',
  'services.store': 'Mağaza',
  'services.balance': 'Balans:',
  'services.username': 'İstifadəçi adı',
  'services.game_name': 'Oyun adı',
  'services.profile': 'Profil',
  'services.password': 'Şifrəni dəyiş',
  'services.password_text': 'Hesab şifrənizi dəyişin.',
  'services.gender': 'Cinsi dəyiş',
  'services.gender_text': 'Cins məlumatınızı dəyişin.',
  'services.name': 'Oyun adını dəyiş',
  'services.name_text': 'Oyunlarda görünən adı dəyişin.',
  'services.photo': 'Profil şəklini dəyiş',
  'services.photo_text': 'Profil şəklinizi fərdiləşdirin.',
  'services.back': 'GERİ',
  'services.password_current': 'Cari şifrə',
  'services.password_new': 'Yeni şifrə (ən azı 6 simvol)',
  'services.password_repeat': 'Yeni şifrəni təkrarlayın',
  'services.password_hint': 'Şifrə ilə saytda ID-nizlə daxil ola bilərsiniz.',
  'services.password_mismatch': 'Şifrələr uyğun gəlmir.',
  'services.password_saved': 'Şifrə yadda saxlanıldı.',
  'services.gender_later': 'Onu {date} tarixindən sonra yenidən dəyişə bilərsiniz.',
  'services.name_telegram': 'Telegram adımı istifadə et ({name})',
  'services.photo_pick': 'Şəkil seç',
  'services.photo_telegram': 'Telegram şəklimi istifadə et',
  'login.title': 'Daxil ol',
  'login.login': 'ID və ya @username',
  'login.password': 'Şifrə',
  'login.submit': 'Daxil ol',
  'login.hint': 'Şifrəni oyunda təyin edin: çıxış → Xidmətlər → Şifrəni dəyiş.',
  'login.open_bot': 'Oyunu Telegram-da aç',
  'login.developer': 'Developer girişi',
  'watch.back': 'Geri',
  'watch.live_caps': 'CANLI',
  'watch.live_tab': 'Canlı ({count})',
  'watch.domino_tab': 'Domino ({count})',
  'watch.no_streams': 'Aktiv yayın tapılmadı.',
  'watch.first_stream': 'İlk Yayını Başlat',
  'live.no_other_camera': 'Başqa kamera yoxdur.',
  'courting.title': 'Rəğbət',
  'courting.text': '{name} sənə heyran oldu —',
  'courting.ok': 'Yaxşı',

  // Daily horoscope (menu ≡ → Horoscope).
  'menu.horoscope': 'Bürclər',
  'horoscope.title': 'Bu günün bürc proqnozu',
  'horoscope.pick': 'Bürcünüzü seçin',
  'horoscope.today': 'Bu gün, {date}',
  'horoscope.love_title': 'Sevgi',
  'horoscope.lucky_number': 'Uğurlu rəqəm',
  'horoscope.lucky_color': 'Uğurlu rəng',
  'horoscope.change': 'Bürcü dəyiş',
  'portal.credits': '3D şəkillər: Microsoft Fluent Emoji (MIT). Bürc işarələri: Freepik.',
  'horoscope.sign.aries': 'Qoç',
  'horoscope.sign.taurus': 'Buğa',
  'horoscope.sign.gemini': 'Əkizlər',
  'horoscope.sign.cancer': 'Xərçəng',
  'horoscope.sign.leo': 'Şir',
  'horoscope.sign.virgo': 'Qız',
  'horoscope.sign.libra': 'Tərəzi',
  'horoscope.sign.scorpio': 'Əqrəb',
  'horoscope.sign.sagittarius': 'Oxatan',
  'horoscope.sign.capricorn': 'Oğlaq',
  'horoscope.sign.aquarius': 'Dolça',
  'horoscope.sign.pisces': 'Balıqlar',
  'horoscope.general.0': 'Yeni tanışlıqlar üçün yaxşı gündür. İlk olaraq salam verin.',
  'horoscope.general.1': 'Bu gün enerjiniz yüksəkdir. Butulkanı bir neçə dəfə fırladın!',
  'horoscope.general.2': 'Masada kimsə sizin haqqınızda düşünür.',
  'horoscope.general.3': 'Bu gün sadə olun: zarafat ciddi söhbətdən daha çox qapı açar.',
  'horoscope.general.4': 'Bu gün kiçik hədiyyə böyük təəssürat yarada bilər.',
  'horoscope.general.5': 'İlk təəssüratınıza güvənin, bu gün sizi aldatmayacaq.',
  'horoscope.general.6': 'Sakit gündür. Musiqi və söhbətdən zövq alın.',
  'horoscope.general.7': 'Bu gün uğur cəsurların tərəfindədir. İlk addımı atın.',
  'horoscope.general.8': 'Köhnə dostunuz bu gün sizi təəccübləndirə bilər.',
  'horoscope.general.9': 'Bu gün səbr özünü doğruldacaq. Axşama istədiyinizə çatacaqsınız.',
  'horoscope.love.0': 'Bu günkü öpüş xüsusi bir şeyin başlanğıcı ola bilər.',
  'horoscope.love.1': 'Bu gün təbəssümünüz ən gözəl hədiyyədir.',
  'horoscope.love.2': 'Kimsə sizə gizlicə heyrandır. Masaya baxın.',
  'horoscope.love.3': 'Hisslərinizi açıq deyin, bu qiymətləndiriləcək.',
  'horoscope.love.4': 'Bu gün qarşılıqlı öpüş ehtimalı çox yüksəkdir.',
  'horoscope.love.5': 'Tələsməyin: ən yaxşısı zamanla gəlir.',
  'horoscope.color.0': 'Qırmızı',
  'horoscope.color.1': 'Çəhrayı',
  'horoscope.color.2': 'Qızılı',
  'horoscope.color.3': 'Mavi',
  'horoscope.color.4': 'Yaşıl',
  'horoscope.color.5': 'Bənövşəyi',
};
